import React from 'react';
import SpecialistCard, { Specialist } from './SpecialistCard';

const specialists: Specialist[] = [
  {
    name: 'Dr. Dieter B. C. de Medeiros',
    role: 'Especialista em Transplante Capilar',
    photo: '/assets/img/prof/Dr%20Dieter%20Medeiros.png',
    bio: 'Médico especialista em transplante capilar e procedimentos de restauração capilar. Com formação em técnicas avançadas e mais de 150 cirurgias realizadas, o Dr. Dieter é referência em resultados naturais e duradouros.',
    credentials: [
      'CRM PE 28758',
    ],
  },
  {
    name: 'Drª Arielly de Sousa Leitão',
    role: 'Especialista em Harmonização Facial',
    photo: '/assets/img/prof/Drª%20Arielly%20foto.png',
    credentials: ['CRO 7444'],
    bio: 'Pós-graduada em Harmonização Facial, a Drª Arielly é reconhecida por sua atuação delicada e natural, sempre priorizando resultados que realçam a beleza única de cada paciente. Seu grande diferencial está na rinomodelação, onde alia técnica e sensibilidade para transformar sem exageros, trazendo harmonia e equilíbrio ao rosto.',
    services: ['Rinomodelação', 'Harmonização Facial', 'Preenchimentos'],
  },
  {
    name: 'Dr. Arlley de Sousa Leitão',
    role: 'Cirurgião Implantodontista',
    photo: '/assets/img/prof/Dr%20Arlley.png',
    credentials: ['CRO PB 5135'],
    bio: 'Cirurgião Implantodontista, professor mestre em odontologia, MBA em liderança de alta performance, com 11 anos de experiência em cirurgias na face.',
    services: ['Implantodontia', 'Cirurgias Faciais', 'Harmonização Orofacial'],
  },
  {
    name: 'Drª Brenda Brasileira de Medeiros',
    role: 'Cirurgiã Bucomaxilofacial',
    photo: '/assets/img/prof/Drª%20Brenda.png',
    bio: 'Cirurgiã Bucomaxilofacial formada pela Universidade Federal da Paraíba, com especialização em cirurgias estéticas da face. Membro da Academia Brasileira de Cirurgias Estéticas da Face e Harmonização Facial, combina técnica e sensibilidade em procedimentos de harmonização orofacial.',
    credentials: [
      'CRO 7063',

    ],
  },
  {
    name: 'Drª Flaviana Mendes',
    role: 'Biomédica Esteta',
    photo: '/assets/img/prof/drflaviana.png',
    credentials: ['CRBM 3685'],
    bio: 'Biomédica esteta, atua na área de estética desde 2018, pós-graduada em Biomedicina Estética, Microbiologia e Gestão de Qualidade Laboratorial. Atualmente finalizando a pós-graduação em Ozonioterapia e Docência em nível superior. Vasta experiência na área de saúde, estética e docência em nível técnico e superior.',
  },
  {
    name: 'Dr. João Paulo Lopes Araújo',
    role: 'Médico Cirurgião Facial',
    photo: '/assets/img/prof/drjoaopaulo.png',
    credentials: ['CRM PB 17207'],
    bio: 'Médico formado pela Universidade Federal do Piauí, com pós-graduação em Cirurgias Faciais em Recife. Possui experiência consolidada em procedimentos como face lifting e suas variações técnicas, blefaroplastia superior e inferior, cantopexia, lifting de sobrancelhas, otomodelação e liplifting, sendo responsável por diversos casos de sucesso. Atua em consonância com as atualizações científicas e com a aplicação de abordagens seguras, aliando confiança, seriedade e elegância para transmitir credibilidade técnica com acessibilidade pessoal.',
    services: ['Face Lifting', 'Blefaroplastia', 'Cantopexia', 'Lifting de Sobrancelhas', 'Otomodelação', 'Liplifting'],
  },
];

const SpecialistsList: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
      {specialists.map((sp) => (
        <SpecialistCard key={sp.name} specialist={sp} />
      ))}
    </div>
  );
};

export default SpecialistsList;